export default {
  signIn: 'Kirjaudu sisään',
  signOut: 'Kirjaudu ulos',
  points: 'pistettä',
  hyattSignInButton: 'Kirjaudu World of Hyattiin',
};
